let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("120Xx")).then(() => parcelRequire('boI25'));